import React from "react";
import { Spinner, SpinnerSize, Pivot, PivotItem } from '@fluentui/react';
import SingleQARTask from "./SingleQARTask";
import OwnerSearch from "./OwnerSearch";
import Api from '../../services/Api';
import axios from 'axios';
import PageNavi from "../Administration/PageNavi";
import { Stack } from '@fluentui/react';
import DeliveryCenterButton from "./DeliveryCenterButton";
import MySitesTabs from "./MySitesTabs";
import MyTeamsTabs from "./MyTeamsTabs";
import MyGroups from "./MyGroups";
import MyCharges from "./MyCharges";
import MyPowerPlatform from "./MyPowerPlatform";
import RequestLicenseTask from "./RequestLicenseTask";
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from "../../helpers/HelperMethods";
import DemandRequestButton from "./DemandRequestButton";
import TeamsLiveCollaborationButton from "./TeamsLiveCollaborationButton";
import PowerPlatformHubButton from "./PowerPlatformHubButton";
import MyTasks from "./MyTasks";
import UserGuidesTabs from '../Settings/UserGuidesTabs';
import EditModal from "../EditSite/EditModal";

class ManageCenterContent extends React.Component
{
    constructor(props) {
        super(props);
        
        this.state = {
            isLoading: {
                ownedSites: true,
                coOwnedSites: true,
                ownedTeams: true,
                coOwnedTeams: true,
                groups: true,
                charges: true,
                newSites: true,
                changes: true,
                qars: true,
                powerApps: true,
                flows: true,
                powerAppSolutions: true,
                licenseTasks: false,
                powerAppEnvironments: true
            },
            ownedSites: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            coOwnedSites: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            ownedTeams: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            coOwnedTeams: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            groups: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            charges: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            newSites: {
                results: []
            },
            licenseTasks: [],
            changes : [],
            changeTypes : null,
            changeTypesLoaded : false,
            qars: [],
            powerApps: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            flows: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            powerAppSolutions: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            powerAppEnvironments: {
                results: [],
                totalCount: 0,
                page: 1,
                onPage: 100
            },
            isNotificationOnly: false,
            qarTasksToRefresh: false,
            error: false,
            powerAppChanges: [],
            powerAppSolutionChanges: [],
            powerAppEnvironmentChanges: [],
            powerAppSolutionId: null
        };
    }

    downloadData()
    {
        //this.getChangeTypes();
        this.getItems('sitesOwner', 'ownedSites');
        this.getItems('sitesCoOwner', 'coOwnedSites');
        this.getItems('teamsOwner', 'ownedTeams');
        this.getItems('teamsCoOwner', 'coOwnedTeams');
        this.getItems('groupsOwner', 'groups');
        this.getItems('charges', 'charges');
        this.getItems('approver', 'newSites');
        this.getChangeTasks('approver', 'changes', 'ApproverTasks');
        this.getChangeTasks('approver', 'powerAppChanges', 'PowerAppChangeTask');
        this.getChangeTasks('approver', 'powerAppSolutionChanges', 'PowerAppSolutionChangeTask');
        this.getChangeTasks('approver', 'powerAppEnvironmentChanges', 'PowerAppEnvironmentChangeTask');
        this.getQARTasks('approver');
        this.getLicenseTasks('approver');
        this.getItems('owner', 'powerApps', 'PowerAppsPanel', `type=powerApp&fromSolutions=false`);
        this.getItems('owner', 'flows', 'PowerAppsPanel', `type=flow&fromSolutions=false`);
        this.getItems('owner', 'powerAppSolutions', 'PowerAppSolutionsPanel', 'isTileView=true&getSupportingSolutions=false');
        this.getItems('owner', 'powerAppEnvironments', 'EnvironmentsPanel');
    }

    componentDidMount() {
        this.axiosCancelSource = axios.CancelToken.source();

        this.downloadData();
    }
    
    componentWillUnmount() {
        this.axiosCancelSource.cancel();
    }

    getItems(filterBy, results, endpoint = 'SitesPanel', queryString = '') {
        this.setState((prevState) => ({
            isLoading: {
                ...prevState.isLoading,
                [results]: true
            }
        }));

        let url = `/${endpoint}?filterBy=${filterBy}${queryString ? `&${queryString}` : ''}`;
        if (this.state[results].page) {
            url += `&page=${this.state[results].page}&onPage=${this.state[results].onPage}`;
        }

        Api.get(url, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(sitesResults => {
            this.setState((prevState) => ({
                isLoading: {
                    ...prevState.isLoading,
                    [results]: false
                },
                [results]: {
                    ...prevState[results],
                    ...sitesResults
                }
            }));
        })
        .catch(error => {
            this.setState((prevState) => ({ isLoading: { ...prevState.isLoading, [results]: false }}));
            console.log(error);
        });
    }

    getChangeTasks(filterBy, results, endpoint) {
        this.setState((prevState) => ({
            isLoading: {
                ...prevState.isLoading,
                [results]: true
            }
        }));

        Api.get(`/${endpoint}?filterBy=${filterBy}&includeChangeDbObject=true`, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(tasks => {
            this.setState((prevState) => ({
                isLoading: {
                    ...prevState.isLoading,
                    [results]: false
                },
                [results]: tasks
            }));
        })
        .catch(error => {
            this.setState((prevState) => ({ isLoading: { ...prevState.isLoading, [filterBy]: false }}));
            console.log(error);
        });
    }

    getQARTasks(filterBy) {
        this.setState((prevState) => ({
            isLoading: {
                ...prevState.isLoading,
                qars: true
            }
        }));
        
        Api.get(`/QARTasks?filterBy=${filterBy}`, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(sites => {
            this.setState((prevState) => ({
                isLoading: {
                    ...prevState.isLoading,
                    qars: false
                },
                qars: sites
            }));
        })
        .catch(error => {
            this.setState((prevState) => ({ isLoading: { ...prevState.isLoading, [filterBy]: false }}));
            console.log(error);
        });
    }

    getLicenseTasks(filterBy) {
        this.setState((prevState) => ({
            isLoading: {
                ...prevState.isLoading,
                licenseTasks: true
            }
        }));

        Api.get(`/RequestLicenseTasks?filterBy=${filterBy}`, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(tasks => {
            this.setState((prevState) => ({
                isLoading: {
                    ...prevState.isLoading,
                    licenseTasks: false
                },
                licenseTasks: tasks
            }));
        })
        .catch(error => {
            this.setState((prevState) => ({
                isLoading: {
                    ...prevState.isLoading,
                    [filterBy]: false
                }
            }));
            console.log(error);
        });
    }

    getChangeTypes()
    {
        Api.get(`/ChangeType?p=1`, {
            cancelToken: this.axiosCancelSource.token
        })
        .then(res => res.data)
        .then(sites => {
            this.setState((prevState) => ({

                changeTypes : sites,
                changeTypesLoaded: true,
            }));
        })
        .catch(error => {
            console.log(error);
        });
    }

    refresh = () => {
        this.downloadData();
    }

    getObjectById = async (id, endpoint) => {
        const result = await Api.get(`/${endpoint}?id=${id}`);

        return result.data;
    }

    onEditCallback = async (id, data, endpoint) => {
        const site = await this.getObjectById(id, endpoint);

        const items = this.state[data].results;
        const updatedItems = items.map(x => (x.id === id) ? site : x);

        this.setState({[data]: { ...this.state[data], results: updatedItems}});
    }
    
    onGetCallback = (value, data) => {
        const items = this.state[data].results;
        const updatedItems = items.map(x => (x.id === value.id) ? value : x);

        this.setState((prevState) => ({
            ...prevState,
            [data]: {
                ...prevState[data],
                results: updatedItems
            }
        }));
    }    

    getUrlParams(paramName)
    {
        let url_string = window.location.href;
        let url = new URL(url_string);
        let paramValue = url.searchParams.get(paramName);
        return paramValue;
    }

    getQarTaskFromUrl() {
        const qarTaskId = this.getUrlParams("qarTaskId");
        return qarTaskId ? this.state.qars.find(x => x.id === Number(qarTaskId)) : null;
    }

    getLicenseTaskFromUrl() {
        const taskId = this.getUrlParams("licenseTaskId");
        return taskId ? this.state.licenseTasks.find(x => x.id === Number(taskId)) : null;
    }

    getPowerAppTaskFromUrl() {
        const powerAppTaskId = this.getUrlParams('powerAppTaskId')
        return powerAppTaskId ? this.state.powerAppChanges.find(x => x.id === Number(powerAppTaskId)) : null
    }

    getPowerAppSolutionTaskFromUrl() {
        const powerAppSolutionTaskId = this.getUrlParams('powerAppSolutionTaskId')
        return powerAppSolutionTaskId ? this.state.powerAppSolutionChanges.find(x => x.id === Number(powerAppSolutionTaskId)) : null
    }

    setPageUrlFilter = (results, filterBy, value, endpoint, query = '') => {
        this.setState({
            [results]: {
                ...this.state[results],
                page: value
            }
        }, () => { this.getItems(filterBy, results, endpoint, query) });
    }

    getPageNavi(results, filterBy, endpoint, query = '') {
        return  this.state[results].totalCount > this.state[results].onPage &&
                <div style={{flexBasis: '100%'}}>
                    <PageNavi
                        pageNumPart = {(value) => this.setPageUrlFilter(results, filterBy, value, endpoint, query)}
                        resultsOnPage = {this.state[results].onPage}
                        pageNum = {this.state[results].page}
                        totalResults = {this.state[results].totalCount}
                    />
                </div>
        
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.qarTasksToRefresh !== this.state.qarTasksToRefresh) {
          this.refresh();
        }
    }

    bulkApproveQARTasks = () => {

        this.setState({ error: false, qarTasksToRefresh: false });

        Api.post('/BulkApproveQARTasks', {})
            .then(res => res.data)
            .then(post => {
                if (post === 200) {
                    this.setState({ qarTasksToRefresh: true })
                } else {
                    this.setState({ error: true })
                }
            }
            ).catch((error) => {
                this.setState({ error: true})
                console.log(error)
            });
    }

    onFilterToggleChange = (filterBy, results, endpoint, query) => {
        this.setState((prevState) => ({
            [results]: {
                ...prevState[results],
                page: 1,
            }
        }), () => this.getItems(filterBy, results, endpoint, query))
    }

    removeUrlParam(param) {
        window.location.href = window.location.origin + window.location.pathname + window.location.hash
    }

    onShowPowerAppSolutionModal = (id) => {
        this.setState({powerAppSolutionId: id})
    }

    sitesTotal = () => {
        var ownedSitesTotal = this.state.ownedSites.totalCount > 0 ? this.state.ownedSites.totalCount : 0;
        var coOwnedSitesTotal = this.state.coOwnedSites.totalCount > 0 ? this.state.coOwnedSites.totalCount : 0;
        return ownedSitesTotal + coOwnedSitesTotal;
    }

    teamsTotal = () => {
        var ownedTeamsTotal = this.state.ownedTeams.totalCount > 0 ? this.state.ownedTeams.totalCount : 0;
        var coOwnedTeamsTotal = this.state.coOwnedTeams.totalCount > 0 ? this.state.coOwnedTeams.totalCount : 0;
        return ownedTeamsTotal + coOwnedTeamsTotal;
    }

    groupsTotal = () => {
        var groupsTotal = this.state.groups.totalCount > 0 ? this.state.groups.totalCount : 0;
        return groupsTotal;
    }

    chargesTotal = () => {
        var chargesTotal = this.state.charges.totalCount > 0 ? this.state.charges.totalCount : 0;
        return chargesTotal;
    }

    render() {
        
        const qarTask = this.getQarTaskFromUrl(); 
        const qarTaskDialog = qarTask &&
                                <SingleQARTask
                                    key = {qarTask.id + qarTask.label}
                                    element = {qarTask}
                                    showDialog = {true}
                                    refresh = {this.refresh}
                                />

        const licenseTask = this.getLicenseTaskFromUrl();
        const licenseTaskDialog = licenseTask && 
                                <RequestLicenseTask
                                    key = {licenseTask.id}
                                    task = {licenseTask}
                                    refresh = {this.refresh}
                                    showDialog = {true}
                                />

        const powerAppId = this.getUrlParams('powerAppId')
        const powerAppDialog =  powerAppId &&
                                    <EditModal
                                        itemId={powerAppId}
                                        isModalOpened={true}
                                        isEditable={true}
                                        isPowerApp={true}
                                        onCloseModal={this.removeUrlParam}
                                        showSolutionModal={this.onShowPowerAppSolutionModal}
                                    />
                                
        const powerAppSolutionId = this.getUrlParams('powerAppSolutionId')
        const powerAppSolutionDialog = 
                                (powerAppSolutionId &&
                                    <EditModal
                                        itemId={powerAppSolutionId}
                                        isModalOpened={true}
                                        isEditable={true}
                                        isPowerAppSolution={true}
                                        onCloseModal={this.removeUrlParam}
                                    />
                                ) ||
                                (this.state.powerAppSolutionId &&
                                    <EditModal
                                        itemId={this.state.powerAppSolutionId}
                                        isModalOpened={true}
                                        isEditable={true}
                                        isPowerAppSolution={true}
                                        onCloseModal={() => this.setState({powerAppSolutionId: null})}
                                    />
                                )

        const powerAppEnvironmentId = this.getUrlParams('powerAppEnvironmentId')
        const powerAppEnvironmentDialog = powerAppEnvironmentId &&
                                            <EditModal
                                                itemId={powerAppEnvironmentId}
                                                isModalOpened={true}
                                                isEditable={true}
                                                isPowerAppEnvironment={true}
                                                onCloseModal={this.removeUrlParam}
                                            />
                                
        const ownedSitesPageNavi = this.getPageNavi('ownedSites', 'sitesOwner');
        const coOwnedSitesPageNavi = this.getPageNavi('coOwnedSites', 'sitesCoOwner');
        const ownedTeamsPageNavi = this.getPageNavi('ownedTeams', 'teamsOwner');
        const coOwnedTeamsPageNavi = this.getPageNavi('coOwnedTeams', 'teamsCoOwner');
        const groupsPageNavi = this.getPageNavi('groups', 'groupsOwner');
        const chargesPageNavi = this.getPageNavi('charges', 'charges');

        const defaultSelectedKey = getPivotItemKeyFromUrl('MySites');
        const spinner = <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />;

        const isTasksLoading = this.state.isLoading.newSites || this.state.isLoading.changes || this.state.isLoading.qars || this.state.isLoading.licenseTasks || this.state.isLoading.powerAppChanges || this.state.isLoading.powerAppSolutionChanges || this.state.isLoading.powerAppEnvironmentChanges;

        return (
            <div style={{backgroundColor: '#F8F8F8', minHeight:'500px', padding:'20px 20px 20px 20px'}}>
                {qarTaskDialog}
                {licenseTaskDialog}
                {powerAppDialog}
                {powerAppSolutionDialog}
                {powerAppEnvironmentDialog}
                <Stack horizontal reversed>
                </Stack>
                <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl()}>
                    <PivotItem itemKey='MySites' headerText='My SharePoint Sites'
                    itemCount={this.state.isLoading.ownedSites || this.state.isLoading.coOwnedSites ? undefined : this.sitesTotal() }>
                        {
                            <div style={pivotItemStyles}>
                                <MySitesTabs 
                                    parentPivotKey='MySites'
                                    isLoadingOwnedSites={this.state.isLoading.ownedSites}
                                    isLoadingcoOwnedSites={this.state.isLoading.coOwnedSites}
                                    ownedSites={this.state.ownedSites}
                                    coOwnedSites={this.state.coOwnedSites}
                                    ownedSitesPageNavi={ownedSitesPageNavi}
                                    coOwnedSitesPageNavi={coOwnedSitesPageNavi}
                                    editCallback={this.onEditCallback.bind(this)}
                                />
                            </div>
                        }
                        <DemandRequestButton />
                        <DeliveryCenterButton />
                    </PivotItem>
                    <PivotItem itemKey='MyTeams' headerText='My Teams'
                        itemCount={this.state.isLoading.ownedTeams || this.state.isLoading.coOwnedTeams ? undefined : this.teamsTotal() }>
                        {
                            <div style={pivotItemStyles}>
                                <MyTeamsTabs 
                                    parentPivotKey='MyTeams'
                                    isLoadingOwnedTeams={this.state.isLoading.ownedTeams}
                                    isLoadingcoOwnedTeams={this.state.isLoading.coOwnedTeams}
                                    ownedTeams={this.state.ownedTeams}
                                    coOwnedTeams={this.state.coOwnedTeams}
                                    ownedTeamsPageNavi={ownedTeamsPageNavi}
                                    coOwnedTeamsPageNavi={coOwnedTeamsPageNavi}
                                    editCallback={this.onEditCallback.bind(this)}
                                />
                            </div>
                        }
                        <DemandRequestButton />
                        <TeamsLiveCollaborationButton />
                    </PivotItem>
                    <PivotItem itemKey='MyGroups' headerText='My Groups'
                        itemCount={this.state.isLoading.groups ? undefined : this.groupsTotal() }>
                        {
                            this.state.isLoading.groups ? spinner
                            : 
                            <div style={pivotItemStyles}>
                                <MyGroups 
                                    groups={this.state.groups.results}
                                />
                                {groupsPageNavi}
                            </div>
                        }
                        <DemandRequestButton />
                        <DeliveryCenterButton />
                    </PivotItem>
                    <PivotItem itemKey='MyCharges' headerText='My Charges'
                        itemCount={this.state.isLoading.charges ? undefined : this.chargesTotal() }>
                        {
                            this.state.isLoading.charges ? spinner
                            : 
                            <div style={pivotItemStyles}>
                                <MyCharges 
                                    charges={this.state.charges.results}
                                />
                                {chargesPageNavi}
                            </div>
                        }
                        <DemandRequestButton />
                        <DeliveryCenterButton />
                    </PivotItem>
                    <PivotItem itemKey='MyPowerPlatform' headerText='My PowerPlatform' 
                               itemCount={(this.state.powerApps.allTotalCount === undefined || this.state.flows.allTotalCount === undefined || this.state.powerAppSolutions.allTotalCount === undefined || this.state.powerAppEnvironments.allTotalCount === undefined) 
                                            ? undefined 
                                            : this.state.powerApps.allTotalCount + this.state.flows.allTotalCount + this.state.powerAppSolutions.allTotalCount + this.state.powerAppEnvironments.allTotalCount}>
                        <MyPowerPlatform 
                            apps={this.state.powerApps} 
                            flows={this.state.flows} 
                            solutions={this.state.powerAppSolutions}
                            environments={this.state.powerAppEnvironments}
                            getCallback={this.onGetCallback}
                            getPageNavi={this.getPageNavi.bind(this)}
                            isLoading={this.state.isLoading}
                            parentPivotKey='MyPowerPlatform'
                            onFilterToggleChange={this.onFilterToggleChange}
                         />
                         <PowerPlatformHubButton />
                    </PivotItem>
                    <PivotItem itemKey='MyTasks' headerText='My Tasks' itemCount={isTasksLoading ? undefined : (this.state.newSites.results.length + this.state.changes.length + this.state.qars.length + this.state.licenseTasks.length + this.state.powerAppChanges.length + this.state.powerAppSolutionChanges.length + this.state.powerAppEnvironmentChanges.length)}>
                        <MyTasks
                            newSitesTasks={this.state.newSites.results}
                            changeSiteTasks={this.state.changes}
                            licenseTasks={this.state.licenseTasks}
                            qarTasks={this.state.qars}
                            powerAppChanges={this.state.powerAppChanges}
                            powerAppSolutionChanges={this.state.powerAppSolutionChanges}
                            powerAppEnvironmentChanges={this.state.powerAppEnvironmentChanges}
                            bulkApproveQARTasks={this.bulkApproveQARTasks}
                            isTasksLoading={isTasksLoading}
                            refresh={this.refresh}
                            getCallback={this.onGetCallback}
                        />
                        <DemandRequestButton />
                        <DeliveryCenterButton />
                    </PivotItem>
                    <PivotItem itemKey='OwnerSearch' headerText='Administrator search'>
                        <OwnerSearch />
                        <DemandRequestButton />
                        <DeliveryCenterButton />
                    </PivotItem>
                    <PivotItem itemKey='UserGuides' headerText='User Guides'>
                        <UserGuidesTabs parentPivotKey='UserGuides' adminEditMode={false}/>
                        <DemandRequestButton />
                        <DeliveryCenterButton />
                    </PivotItem>
                </Pivot>
            </div>
        );
    }

    
}

const pivotStyles = {
    root: {
        marginBottom: 20,
        whiteSpace: 'pre-wrap',
        //maxWidth: 'calc(100% - 450px)',
        //minWidth: 300
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

const pivotItemStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    width: "100%"
}

export default ManageCenterContent


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ManageCenterContent.js